export interface GalleryImage {
  title: string;
  desc: string;
  url: string;
  universe: string;
  imageSize: string;
  finish: string;
  isCommission: boolean;
}

export const galleryImages: GalleryImage[] = [
  {
    title: "Vallory",
    desc: "",
    url: "/vallory.jpg",
    universe: "",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Ryndri",
    desc: "",
    url: "/ryndri2.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Ryndri",
    desc: "",
    url: "/ryndri.jpg",
    universe: "warcraft",
    imageSize: "full body",
    finish: "watercolour",
    isCommission: false,
  },
  {
    title: "Neefia",
    desc: "",
    url: "/neefia7.jpg",
    universe: "warcraft",
    imageSize: "half body",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Allura and Mileni",
    desc: "",
    url: "/allura+mileni.jpg",
    universe: "Elder Scrolls",
    imageSize: "portrait",
    finish: "watercolour",
    isCommission: false,
  },
  {
    title: "Aekirus",
    desc: "",
    url: "/aekirus.jpg",
    universe: "warcraft",
    imageSize: "half body",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Gilnean",
    desc: "",
    url: "/gilnean.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "watercolour",
    isCommission: true,
  },
  {
    title: "Draenei",
    desc: "",
    url: "/draenei2.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "watercolour",
    isCommission: true,
  },
  {
    title: "Celenthiel",
    desc: "",
    url: "/celenthiel2.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Celenthiel",
    desc: "",
    url: "/celenthiel.jpg",
    universe: "warcraft",
    imageSize: "half body",
    finish: "watercolour",
    isCommission: true,
  },
  {
    title: "Tabitha",
    desc: "",
    url: "/tabitha.jpg",
    universe: "",
    imageSize: "portrait",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Maia",
    desc: "",
    url: "/maia.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "portrait",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Zoysia and Kahalari",
    desc: "",
    url: "/zoysia.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "half body",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Quilynn",
    desc: "",
    url: "/quilynn.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "portrait",
    finish: "painted",
    isCommission: true,
  },
  {
    title: "Iraebryn",
    desc: "",
    url: "/iraebryn.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Sirenagosa",
    desc: "",
    url: "/sirenagosa.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Ecatée",
    desc: "",
    url: "/ecatee2.jpg",
    universe: "",
    imageSize: "half body",
    finish: "sketch",
    isCommission: false,
  },
  {
    title: "Sea Nymph",
    desc: "",
    url: "/nymph.jpg",
    universe: "",
    imageSize: "half body",
    finish: "watercolour",
    isCommission: false,
  },
  {
    title: "Belisra",
    desc: "",
    url: "/belisra.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Fayra",
    desc: "",
    url: "/fayra2.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "portrait",
    finish: "painted",
    isCommission: true,
  },
  {
    title: "Rinh",
    desc: "",
    url: "/rinh7.jpg",
    universe: "FFXIV",
    imageSize: "portrait",
    finish: "watercolour",
    isCommission: false,
  },
  {
    title: "Elara",
    desc: "",
    url: "/elara2.jpg",
    universe: "Elder Scrolls",
    imageSize: "portrait",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Eros and Iris",
    desc: "",
    url: "/eros+iris.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Ser Duncan",
    desc: "",
    url: "/serduncan.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Dionysus",
    desc: "",
    url: "/dionysus2.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Dionysus",
    desc: "",
    url: "/dionysus.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Benjamin",
    desc: "",
    url: "/benjamin.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Lillian",
    desc: "",
    url: "/lillian.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Auxélie and Lucy",
    desc: "",
    url: "/auxelie+lucy.jpg",
    universe: "warcraft",
    imageSize: "half body",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Haelissa",
    desc: "",
    url: "/haelissa.jpg",
    universe: "",
    imageSize: "half body",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Tae",
    desc: "",
    url: "/tae.jpg",
    universe: "warcraft",
    imageSize: "half body",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Cloverhoney",
    desc: "",
    url: "/cloverhoney.jpg",
    universe: "warcraft",
    imageSize: "full body",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Rose",
    desc: "",
    url: "/rose.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "painted",
    isCommission: true,
  },
  {
    title: "Amrathor",
    desc: "",
    url: "/amrathor.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: false,
  },
  {
    title: "Saedre",
    desc: "",
    url: "/saedre.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Valerial",
    desc: "",
    url: "/valerial.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Kalrissa",
    desc: "",
    url: "/kalrissa.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "portrait",
    finish: "painted",
    isCommission: true,
  },
  {
    title: "Scyene",
    desc: "",
    url: "/scyene.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Kasania",
    desc: "",
    url: "/kasania.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Llewellyn",
    desc: "",
    url: "/llewellyn.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "M'iko",
    desc: "",
    url: "/miko.jpg",
    universe: "FFXIV",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Helyne",
    desc: "",
    url: "/helyne.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Ceto",
    desc: "",
    url: "/ceto.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Demon",
    desc: "",
    url: "/demon.jpg",
    universe: "warcraft",
    imageSize: "full body",
    finish: "sketch",
    isCommission: false,
  },
  {
    title: "Draenei",
    desc: "",
    url: "/draenei.jpg",
    universe: "warcraft",
    imageSize: "full body",
    finish: "sketch",
    isCommission: false,
  },
  {
    title: "Sellène",
    desc: "",
    url: "/sellene.jpg",
    universe: "",
    imageSize: "half body",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Ti",
    desc: "",
    url: "/ti.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "half body",
    finish: "painted",
    isCommission: true,
  },
  {
    title: "Whitemane",
    desc: "",
    url: "/whitemane.jpg",
    universe: "warcraft",
    imageSize: "half body",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Rinh",
    desc: "",
    url: "/rinh6.jpg",
    universe: "FFXIV",
    imageSize: "full body",
    finish: "sketch",
    isCommission: false,
  },
  {
    title: "Lehen",
    desc: "",
    url: "/lehen.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Zalorii",
    desc: "",
    url: "/zalorii.jpg",
    universe: "warcraft",
    imageSize: "half body",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Maeve",
    desc: "",
    url: "/maeve.jpg",
    universe: "",
    imageSize: "portrait",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Athriel",
    desc: "",
    url: "/athriel.jpg",
    universe: "warcraft",
    imageSize: "half body",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Rin",
    desc: "",
    url: "/rin.jpg",
    universe: "warcraft",
    imageSize: "half body",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Eirian",
    desc: "",
    url: "/eirian.jpg",
    universe: "",
    imageSize: "half body",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Opal",
    desc: "",
    url: "/opal.jpg",
    universe: "warcraft",
    imageSize: "half body",
    finish: "painted",
    isCommission: true,
  },
  {
    title: "Wraith",
    desc: "",
    url: "/wraith.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Mariko",
    desc: "",
    url: "/mariko.jpg",
    universe: "FFXIV",
    imageSize: "half body",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Elyanthe",
    desc: "",
    url: "/elyanthe.jpg",
    universe: "warcraft",
    imageSize: "half body",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Rhynali",
    desc: "",
    url: "/rhynali.jpg",
    universe: "warcraft",
    imageSize: "half body",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Kalendar",
    desc: "",
    url: "/kalendar.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "half body",
    finish: "sketch",
    isCommission: true,
  },
  {
    title: "Zhaleh",
    desc: "",
    url: "/zhaleh.jpg",
    universe: "",
    imageSize: "half body",
    finish: "sketch",
    isCommission: false,
  },
  {
    title: "Syrinah",
    desc: "",
    url: "/syrinah.jpg",
    universe: "warcraft",
    imageSize: "half body",
    finish: "sketch",
    isCommission: false,
  },
  {
    title: "Jaeltha",
    desc: "",
    url: "/jaeltha.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "half body",
    finish: "sketch",
    isCommission: false,
  },
  {
    title: "Zaielsie",
    desc: "",
    url: "/zaielsie.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "half body",
    finish: "sketch",
    isCommission: false,
  },
  {
    title: "Neefia",
    desc: "",
    url: "/neefia6.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Mileni",
    desc: "",
    url: "/mileni3.jpg",
    universe: "Elder Scrolls",
    imageSize: "half body",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Calyssra",
    desc: "",
    url: "/calyssra.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "painted",
    isCommission: true,
  },
  {
    title: "Tristane",
    desc: "",
    url: "/tristane.jpg",
    universe: "Elder Scrolls",
    imageSize: "half body",
    finish: "painted",
    isCommission: true,
  },
  {
    title: "Quartise",
    desc: "",
    url: "/quartise.jpg",
    universe: "",
    imageSize: "half body",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Neefia",
    desc: "",
    url: "/neefia-costume.jpg",
    universe: "warcraft",
    imageSize: "full body",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Elara",
    desc: "",
    url: "/elara.jpg",
    universe: "Elder Scrolls",
    imageSize: "portrait",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Rinh",
    desc: "",
    url: "/rinh4.jpg",
    universe: "FFXIV",
    imageSize: "portrait",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Luna",
    desc: "",
    url: "/luna.jpg",
    universe: "",
    imageSize: "portrait",
    finish: "painted",
    isCommission: false,
  },
  {
    title: "Anastaise",
    desc: "",
    url: "/anastaise.jpg",
    universe: "warcraft",
    imageSize: "half body",
    finish: "painted",
    isCommission: true,
  },
  {
    title: "Fayra",
    desc: "",
    url: "/fayra.jpg",
    universe: "Dungeons and Dragons",
    imageSize: "portrait",
    finish: "painted",
    isCommission: true,
  },
  {
    title: "Razlaria",
    desc: "",
    url: "/razlaria.jpg",
    universe: "Elder Scrolls",
    imageSize: "half body",
    finish: "painted",
    isCommission: true,
  },
  {
    title: "Lunariia",
    desc: "",
    url: "/lunariia.jpg",
    universe: "warcraft",
    imageSize: "portrait",
    finish: "painted",
    isCommission: true,
  },
  {
    title: "Myriani",
    desc: "",
    url: "/myriani.jpg",
    universe: "FFXIV",
    imageSize: "half body",
    finish: "painted",
    isCommission: true,
  },
  {
    title: "Erelah",
    desc: "",
    url: "/erelah.jpg",
    universe: "warcraft",
    imageSize: "half body",
    finish: "painted",
    isCommission: true,
  },
  {
    title: "Serana",
    desc: "",
    url: "/serana.jpg",
    universe: "Elder Scrolls",
    imageSize: "portrait",
    finish: "painted",
    isCommission: false,
  },
];
